<template>
    <!--分页-->
    <div @click="setEditIndex(index)">
        <el-row :gutter="10" style="margin-left:5px;height:40px;line-height:40px">
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="item_container_title">
                <div style="margin-left:33px">页码 :&nbsp;&nbsp;&nbsp;{{question.pageNumber}}</div>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="item_time">
                <p v-if="question.minTimeSwitch">最短时间<span class="time">{{question.minTime}}秒</span></p>
                <p v-if="question.maxTimeSwitch">最长时间<span class="time">{{question.maxTime}}秒</span></p>
            </el-col>
            <el-col class="edit-btn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <i class="el-icon-delete edit-btn" 
                    v-if="question.isedit"
                    @click="questiondel(question.qid)"></i>
                <i v-if="question.pageNumber!=1" class="el-icon-rank edit-btn item drag-handle"></i>
            </el-col>
           
        </el-row>
    </div>
</template>
<script>
    export default {
        inject: ['reload'],
        data() {
            return {
              
            }
        },
        props: {
            question: {},
            index: {type:Number,default:0}
        },
      
        methods: {
            updateQuestion(){
                this.$emit("wjupdquestionoption",this.question);
                this.reload()
            },
            wjupdoption(item){
                this.$emit("wjupdoption",item);
                this.reload()
            },
            showAdvance(e) {
                this.$emit("showAdvance",e);
                // this.reload()
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            questiondel(id){
                this.$emit("questiondel",id);
            }
        },
        created() {
            // console.log('paging',this.question)
            // this.$router.go(0)
        }
    }
</script>

<style scoped lang="scss">
    .inputvalue{
        border: 1px solid rgb(154, 145, 145);
        width: 770px;
        height: 35px;
    }
    .edit-btn-box{    
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .edit-btn{
            font-size: 22px;
            line-height: 40px;
            text-align: right;
            cursor: pointer;
        }
        .edit-btn+.edit-btn{
            margin-left: 30px;
        }
    }
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        line-height: 40px;
        height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .askxh {
        line-height: 40px;
        text-align: right;
    }

    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    
    .item_time{
        height: 40px;
        font-size: 14px;
        text-align: center;
    }
    .item_time p{
        display: inline-block;
    }
    .item_time .time{
        color: #2672ff;
    }
    .item_time p+p{
        display: inline-block;
        margin-left: 10px;
    }
</style>
